import { render } from "./CopyrightFooter.vue?vue&type=template&id=8b4f7f66&scoped=true"
import script from "./CopyrightFooter.vue?vue&type=script&lang=js"
export * from "./CopyrightFooter.vue?vue&type=script&lang=js"

import "./CopyrightFooter.vue?vue&type=style&index=0&id=8b4f7f66&scoped=true&lang=css"

import exportComponent from "/tmp/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4f7f66"]])

export default __exports__